import styled, { css } from "styled-components";
import { Atom, Wrapper, wrap } from "AppReact";

const wrapperTemplate = styled.div`
  width: 100%;
  background-color: #E7EBEB;
  ${({ displayState }) => css`
    height:  ${`${displayState?.height || 8}px`};
  `}
  border-radius: 20px;

  display: flex;
  justify-content: flex-start;
`;

const reversedWrapperTemplate = styled.div`
  width: 100%;
  background-color: #E7EBEB;
  ${({ displayState }) => css`
    height:  ${`${displayState?.height || 8}px`};
  `}
  
  border-radius: 20px;

  display: flex;
  justify-content: flex-end;
`;

const wrapper = Wrapper(wrapperTemplate);
const reversedWrapper = Wrapper(reversedWrapperTemplate);

const template = styled.div`
  ${({ theme, displayState }) => css`
    width: ${`${displayState.progress}%`};
    height: 100%;
    white-space: nowrap;
    display: flex;
    align-items: center;
    text-indent: 14px;
    border-radius: 20px;
    background-color: ${displayState?.color ?? theme?.colour?.primary ?? '#1DBD6B'};
  `}
`;

const ReversedProgressBar = wrap(Atom({ type: 'label', dataType: 'string', template }), reversedWrapper, true);
const ProgressBar = wrap(Atom({ type: 'label', dataType: 'string', template }), wrapper, true);

export {
  ProgressBar,
  ReversedProgressBar
}